import { render, staticRenderFns } from "./BackStage.vue?vue&type=template&id=28fc7c66&scoped=true&lang=pug"
import script from "./BackStage.vue?vue&type=script&lang=js"
export * from "./BackStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fc7c66",
  null
  
)

export default component.exports